export default __webpack_public_path__ + "static/media/property_814.0fa4ee15.png";